import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ValidatorsService} from "@core/validators/validators.service";
import {ParkProvider} from "@providers/park.provider";
import {ThingProvider} from "@providers/thing.provider";
import {ThresholdUtil} from "../../../util/threshold";
import {ThingsUtil} from "../../../util/things";

import { THINGS_ATTRIBUTES_CONFIG } from "../../../constants/things.constants";
import {NotificationService} from "@core/notification/notification.service";
import {KngActivityIndicatorService} from "@layout/kingswell/services/kngActivityIndicator.service";


@Component({
  selector: 'edit-things-attributes',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less'],
  encapsulation: ViewEncapsulation.None
})

export class EditThingsAttributesComponent implements OnInit {

  @Input()
  public thing;

  public form: FormGroup;

  public formConfig: any;

  public showHeaderBottomLine: boolean = false;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private thingProvider: ThingProvider,
              private thingsUtil: ThingsUtil,
              private kngActivityIndicator: KngActivityIndicatorService, private notification: NotificationService) {}

  getFormConfig(config: any, thing: any) {
    let form: any = {};

    config.map(x => {
      form[x.key] = [thing.attributes && thing.attributes[x.key]];
    });

    return form;
  }

  ngOnInit() {
    this.formConfig = this.getAttributeConfig();
    this.form = this.fb.group(this.getFormConfig(this.formConfig, this.thing));
  }

  getAttributeConfig() {
    return THINGS_ATTRIBUTES_CONFIG[this.thing.type] || [];
  }

  submitForm(value: any): void {
    this.kngActivityIndicator.show();
    this.thing.attributes = value;

    this.thingProvider.updateThing(this.thing).then(res => {
      this.kngActivityIndicator.close();
      this.notification.show('success', 'You have successfully edited ' + (this.thing.name || this.thing.thingId) + '.');
      this.activeModal.close(this.thing);
    }).catch((err) => {
      console.error(err);
      this.kngActivityIndicator.close();
      this.notification.show('alert', 'Something went wrong');
    });
  }

  onContentScroll(scrollTop) {
    this.showHeaderBottomLine = (scrollTop > 0);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/attributes/edit.component.ts